import { Injectable, signal } from '@angular/core';

/** Error code of `403 { error: 'page_forbidden' }`: the user has no permission for what the page just tried. */
export const PAGE_FORBIDDEN_CODE = 'page_forbidden';

export function isPageForbiddenBody(body: unknown): boolean {
  return typeof body === 'object' && body !== null && (body as { error?: unknown }).error === PAGE_FORBIDDEN_CODE;
}

const VISIBLE_MS = 8000;

/**
 * Holds the notice "Keine Berechtigung" while it is shown. The page permission is checked by the API for every
 * request, so a stale screen (permission withdrawn after the page loaded) or a call the page never meant to
 * offer ends here instead of as a silent failure or a generic error text.
 */
@Injectable({ providedIn: 'root' })
export class PageForbiddenService {
  readonly visible = signal(false);
  private timer: ReturnType<typeof setTimeout> | null = null;

  show(): void {
    this.visible.set(true);
    if (this.timer) {clearTimeout(this.timer);}
    this.timer = setTimeout(() => this.dismiss(), VISIBLE_MS);
  }

  dismiss(): void {
    if (this.timer) {clearTimeout(this.timer);}
    this.timer = null;
    this.visible.set(false);
  }
}
